import { FormRules } from 'element-plus';

const bodyFormRules: FormRules = {
	name: [{ required: true, message: 'Required field', trigger: 'blur' }],
	type: [{ required: true, message: 'Required field', trigger: 'blur' }],
};

export { bodyFormRules as BodyFormRules };
